import { render, staticRenderFns } from "./RowBlockInsuranceCommissionAutolawyer.vue?vue&type=template&id=c2ea36b6&"
import script from "./RowBlockInsuranceCommissionAutolawyer.vue?vue&type=script&lang=js&"
export * from "./RowBlockInsuranceCommissionAutolawyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports